import React from 'react';
import cx from 'classnames';
import cs from './index.module.scss';

const CaretDownFilledIcon: React.FC<any> = ({ className, ...restProps }) => (
  <span className={cx(cs.container, className)} {...restProps}>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 11.6666L6.66669 8.33325H13.3334L10 11.6666Z" fill="#707070"/>
    </svg>
  </span>
);

export default CaretDownFilledIcon;
